var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-page"},[(_vm.roleKind === 'super')?_c('div',[_c('SuperHome')],1):(_vm.roleKind === 'null')?_c('div',[_c('NoneRoleHome')],1):_c('div',[_c('ApplicationHome')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }